<template>
    <div>
        <img src="./jqr@2x.png" alt="" class="top-img" />
        <div class="title">请告诉小诺，您的性别</div>
        <br />
        <br />
        <div class="flex-box">
            <img src="./n@2x.png" alt="" @click="onClickNext(MALE)" />
            <img src="./v@2x.png" alt="" @click="onClickNext(FEMALE)" />
        </div>
    </div>
</template>

<script>
import { MALE, FEMALE, APPELLATION } from "../../../../enum/GENDER.js";

export default {
    props: {
        index: Number, // 题目顺序
        length: Number, // 题目数量
        isLast: Boolean, // 是否最后一题
        updateAnswer: Function, // 更新答案
        next: Function,
        gender: [String, Number],
    },
    data() {
        this.MALE = MALE;
        this.FEMALE = FEMALE;

        return {};
    },
    methods: {
        onClickNext(value) {
            let gender = APPELLATION[value];
            this.sensorsAdd("BDWebClick", {
                $element_content: "选好了",
                $title: `测评页-第${this.index}题`,
            });

            this.sensorsAdd("BDanswerResult", {
                entrance_location: "",
                question_number: this.index,
                question: `请告诉小诺，您的性别`,
                answer: gender,
            });
            this.updateAnswer(value);
            // 校验通过执行next方法
            this.next();
        },
    },
};
</script>

<style scoped>
.top-img {
    margin: 0.2rem 0 0.5rem 0.22rem;
    width: 1rem;
    height: 0.87rem;
}
.title {
    font-size: 0.15rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #0f2742;
    line-height: 0.19rem;
    text-align: center;
}
.flex-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.4rem;
}
.flex-box img {
    width: 0.84rem;
    height: 0.84rem;
}
</style>
